/**
 * Runs all the functions, with no more than `maxConcurrent` running at once.
 *
 * Fails if any throw.
 **/
export function runAllLimitingConcurrency(
  tasks: (() => Promise<void>)[],
  {
    maxConcurrent = 3,
    abortSignal,
  }: {
    maxConcurrent?: number;
    abortSignal?: AbortSignal;
  } = {},
) {
  if (maxConcurrent < 1) throw new Error('maxConcurrent must be >= 1');
  let i = 0;
  let running = 0;
  return new Promise<void>((resolve, reject) => {
    function runNext() {
      if (i >= tasks.length) {
        if (running === 0) resolve();
        return;
      }
      if (abortSignal?.aborted) {
        i = tasks.length; // don't start any more
        reject(new Error('aborted'));
      }
      const index = i++;
      running++;
      tasks[index]()
        .catch((e) => {
          i = tasks.length; // don't start any more
          reject(e);
        })
        .then(() => {
          running--;
          runNext();
        })
        .catch(reject);
      if (running < maxConcurrent) runNext();
    }
    runNext();
  });
}
